//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faCheck, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { faMeSubscription } from '@motionelements/assets/src/js/me-font/icons-channels2022';
import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';

export default {
  name: 'CorporateComparisonTable',
  components: {
    TeamPlanBanner: () => import('@/components/subscribe/TeamPlanBanner.vue'),
    UnlimitedSubscriptionPrice: () => import('@/components/pricing/UnlimitedSubscriptionPrice.vue'),
  },
  data() {
    return {
      faCheck,
      faXmark,
      faMeSubscription,
    };
  },
  computed: {
    totalSubscriptionCount() {
      return renderContentCount(this, publishedContentCounts.total.subscription.element);
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    list(isUnlimited = false) {
      const list = [
        this.$t('subscription.benefits.private_and_commercial_projects_heading'),
        this.$t('subscription.benefits.use_worldwide_on_all_platforms_heading'),
        this.$t('subscription.benefits.no_extra_fees_heading'),
        this.$t('subscription.benefits.unlimited_downloads_of_over_{number}_content_heading', { number: this.totalSubscriptionCount }),
        this.$t('subscription.benefits.{number}_ai_coins', { number: 1000 }),
        this.$t('subscription.benefits.ai_remix'),
      ];
      return list;
    },
  },
};
